module.exports = __webpack_public_path__ + "static/LogoGreenFR-df1c822308ee5a44d6435bf69c106391.png";